import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/articlespages`;
const token = localStorage.getItem("token");

/// GET
// Fonction pour récupérer tous les articles d'une page personnalisée
export const getAllArticlesByPage = async (pageId) => {
  try {
    const response = await axios.get(
      `${apiUrl}/getAllArticlesByPage/${pageId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      `Erreur lors du chargement des articles de la page ${pageId}:`,
      error
    );
    return [];
  }
};

/// POST
// Fonction pour ajouter un article à une page
export const addArticle = async (article) => {
  try {
    const response = await axios.post(`${apiUrl}/addArticle`, article, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de l'ajout de l'article:", error);
    return null;
  }
};

/// PUT
// Fonction pour modifier un article
export const updateArticle = async (article) => {
  try {
    const response = await axios.put(
      `${apiUrl}/updateArticle/${article.id}`,
      article,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la modification de l'article:", error);
    return null;
  }
};


/// DELETE
// Fonction pour supprimer un article
export const deleteArticle = async (articleId) => {
  try {
    const response = await axios.delete(
      `${apiUrl}/deleteArticle/${articleId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la suppression de l'article:", error);
    return null;
  }
};
